<template>
  <div class="hold-transition">
    <Loading v-if="cargando" />
    <div class="wrapper">
      <div class="content-wrapper">
        <!-- Content Header (Page header) -->
        <section class="content-header py-4">
          <div class="container-fluid">
            <div class="row align-items-center">
              <div class="col-md-6">
                <div class="d-flex align-items-center">
                  <div class="bg-danger rounded-circle p-3 me-3">
                    <i class="fas fa-traffic-light fa-2x text-white"></i>
                  </div>
                  <div>
                    <h1 class="h3 mb-0 fw-bold text-dark ml-1">
                      Central de Tráfico
                    </h1>
                    <p class="mb-0 text-muted ml-1">
                      Monitoreo en tiempo real de novedades
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <ol
                  class="breadcrumb float-sm-right mb-0 bg-light rounded-pill px-3 py-2 border-bottom border-dark shadow-sm"
                >
                  <li class="breadcrumb-item">
                    <router-link
                      to="/"
                      class="text-danger text-decoration-none"
                    >
                      <i class="fas fa-home me-1"></i>Home
                    </router-link>
                  </li>
                  <li class="breadcrumb-item">
                    <router-link
                      to="/Admin"
                      class="text-danger text-decoration-none"
                      >Administrativo</router-link
                    >
                  </li>
                  <li class="breadcrumb-item active text-dark">
                    Central Tráfico
                  </li>
                  <li class="breadcrumb-item active text-dark">
                    Últimas Novedades
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </section>

        <!-- Main content -->
        <section class="content">
          <div class="container-fluid">
            <!-- Pestañas -->
            <div class="card shadow-sm border-0 mb-4">
              <div class="card-body p-0">
                <ul class="nav nav-tabs border-0">
                  <li class="nav-item">
                    <button
                      class="nav-link p-2 border-0"
                      :class="{
                        'active bg-gradient-navy text-white':
                          pestañaActiva === 'ultimasNovedades',
                        'text-muted bg-light':
                          pestañaActiva !== 'ultimasNovedades',
                      }"
                      @click="cambiarPestaña('ultimasNovedades')"
                    >
                      <i class="fas fa-bell me-2"></i>
                      <span class="fw-semibold ml-1">Últimas Novedades</span>
                    </button>
                  </li>
                  <li class="nav-item">
                    <button
                      class="nav-link p-2 border-0"
                      :class="{
                        'active bg-gradient-navy text-white':
                          pestañaActiva === 'hidrocarburos',
                        'text-muted bg-light':
                          pestañaActiva !== 'hidrocarburos',
                      }"
                      @click="cambiarPestaña('hidrocarburos')"
                    >
                      <i class="fas fa-oil-can me-2"></i>
                      <span class="fw-semibold ml-1">Hidrocarburos</span>
                    </button>
                  </li>
                  <li class="nav-item">
                    <button
                      class="nav-link p-2 border-0"
                      :class="{
                        'active bg-gradient-navy text-white':
                          pestañaActiva === 'mapaCalor',
                        'text-muted bg-light':
                          pestañaActiva !== 'mapaCalor',
                      }"
                      @click="cambiarPestaña('mapaCalor')"
                    >
                      <i class="fas fa-fire me-2"></i>
                      <span class="fw-semibold ml-1">Mapa de Calor</span>
                    </button>
                  </li>
                </ul>
              </div>

              <!-- Contenido de Pestañas -->
              <div class="tab-content">
                <!-- Pestaña Últimas Novedades -->
                <div
                  v-if="pestañaActiva === 'ultimasNovedades'"
                  class="tab-pane fade show active"
                >
                  <UltimasNovedadesTab />
                </div>

                <!-- Pestaña Hidrocarburos -->
                <div
                  v-if="pestañaActiva === 'hidrocarburos'"
                  class="tab-pane fade show active"
                >
                  <GestionHidrocarburos />
                </div>

                <!-- Pestaña Mapa de Calor -->
                <div
                  v-if="pestañaActiva === 'mapaCalor'"
                  class="tab-pane fade show active"
                >
                  <MapaCalorNovedades />
                </div>
              </div>
            </div>

            <!-- Modal de Exportar -->
            <div
              class="modal fade"
              id="modalExportar"
              tabindex="-1"
              aria-labelledby="modalExportarLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-xl">
                <div class="modal-content border-0 shadow-lg">
                  <div class="modal-header bg-danger text-white">
                    <div class="d-flex align-items-center">
                      <div
                        class="bg-white bg-opacity-20 rounded-circle p-2 me-3"
                      >
                        <i class="fas fa-file-excel fa-lg"></i>
                      </div>
                      <div>
                        <h5
                          class="modal-title mb-0 fw-bold"
                          id="modalExportarLabel"
                        >
                          Exportar Novedades a Excel
                        </h5>
                        <small class="opacity-75"
                          >Seleccione los filtros para generar el reporte</small
                        >
                      </div>
                    </div>
                    <button
                      type="button"
                      class="btn-close btn-close-white"
                      data-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>

                  <div class="modal-body bg-light">
                    <!-- Alerta informativa -->
                    <div class="alert alert-info border-0 shadow-sm mb-4">
                      <div class="d-flex align-items-start">
                        <div
                          class="bg-info bg-opacity-10 rounded-circle p-2 me-3"
                        >
                          <i class="fas fa-info-circle text-info"></i>
                        </div>
                        <div>
                          <h6 class="mb-2 fw-bold text-info">
                            <i class="fas fa-lightbulb me-1"></i>
                            Instrucciones de Exportación
                          </h6>
                          <div class="row g-2">
                            <div class="col-md-6">
                              <div class="d-flex align-items-center">
                                <i class="fas fa-route text-primary me-2"></i>
                                <small
                                  ><strong>Por Viaje:</strong> Solo necesitas el
                                  número de viaje</small
                                >
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="d-flex align-items-center">
                                <i
                                  class="fas fa-calendar text-success me-2"
                                ></i>
                                <small
                                  ><strong>Por Fechas:</strong> Ingresa al menos
                                  la fecha inicial</small
                                >
                              </div>
                            </div>
                          </div>
                          <div class="mt-2">
                            <small class="text-muted">
                              <i
                                class="fas fa-check-circle text-success me-1"
                              ></i>
                              Las novedades con seguimientos se incluirán
                              automáticamente
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Sección: Rango de Fechas -->
                    <div class="card mb-4 border-0 shadow-sm">
                      <div class="card-header bg-white border-bottom">
                        <div class="d-flex align-items-center">
                          <div
                            class="bg-danger bg-opacity-10 rounded-circle p-2 me-3"
                          >
                            <i class="fas fa-calendar-alt text-danger"></i>
                          </div>
                          <div>
                            <h6 class="mb-0 fw-bold">
                              Rango de Fechas y Horas
                            </h6>
                            <small class="text-muted"
                              >Opcional si hay N° Viaje</small
                            >
                          </div>
                          <span class="badge bg-secondary ms-auto"
                            >Opcional</span
                          >
                        </div>
                      </div>
                      <div class="card-body">
                        <div class="row g-3">
                          <!-- Fecha Desde -->
                          <div class="col-md-3">
                            <label class="form-label fw-semibold">
                              <i class="fas fa-calendar text-danger me-1"></i>
                              Fecha Desde <span class="text-danger">*</span>
                            </label>
                            <div class="input-group">
                              <span
                                class="input-group-text bg-danger bg-opacity-10"
                              >
                                <i class="fas fa-calendar text-danger"></i>
                              </span>
                              <input
                                type="date"
                                class="form-control"
                                v-model="filtrosExportar.fecha_desde"
                                :max="fechaMaxima"
                                :class="{ 'is-invalid': errorFechas }"
                              />
                            </div>
                          </div>

                          <!-- Hora Desde -->
                          <div class="col-md-3">
                            <label class="form-label fw-semibold">
                              <i class="fas fa-clock text-success me-1"></i>
                              Hora Desde
                            </label>
                            <div class="input-group">
                              <span
                                class="input-group-text bg-success bg-opacity-10"
                              >
                                <i class="fas fa-clock text-success"></i>
                              </span>
                              <input
                                type="time"
                                class="form-control"
                                v-model="filtrosExportar.hora_desde"
                              />
                            </div>
                          </div>

                          <!-- Fecha Hasta -->
                          <div class="col-md-3">
                            <label class="form-label fw-semibold">
                              <i
                                class="fas fa-calendar-check text-warning me-1"
                              ></i>
                              Fecha Hasta <span class="text-danger">*</span>
                            </label>
                            <div class="input-group">
                              <span
                                class="input-group-text bg-warning bg-opacity-10"
                              >
                                <i
                                  class="fas fa-calendar-check text-warning"
                                ></i>
                              </span>
                              <input
                                type="date"
                                class="form-control"
                                v-model="filtrosExportar.fecha_hasta"
                                :max="fechaMaxima"
                                :class="{ 'is-invalid': errorFechas }"
                              />
                            </div>
                            <div
                              v-if="errorFechas"
                              class="invalid-feedback d-block"
                            >
                              <i class="fas fa-exclamation-triangle me-1"></i>
                              {{ mensajeErrorFechas }}
                            </div>
                          </div>

                          <!-- Hora Hasta -->
                          <div class="col-md-3">
                            <label class="form-label fw-semibold">
                              <i class="fas fa-clock text-info me-1"></i>
                              Hora Hasta
                            </label>
                            <div class="input-group">
                              <span
                                class="input-group-text bg-info bg-opacity-10"
                              >
                                <i class="fas fa-clock text-info"></i>
                              </span>
                              <input
                                type="time"
                                class="form-control"
                                v-model="filtrosExportar.hora_hasta"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Sección: Filtros Principales -->
                    <div class="card mb-4 border-0 shadow-sm">
                      <div class="card-header bg-white border-bottom">
                        <div class="d-flex align-items-center">
                          <div
                            class="bg-danger bg-opacity-10 rounded-circle p-2 me-3"
                          >
                            <i class="fas fa-filter text-danger"></i>
                          </div>
                          <div>
                            <h6 class="mb-0 fw-bold">Filtros de Búsqueda</h6>
                            <small class="text-muted"
                              >Seleccione los criterios para filtrar</small
                            >
                          </div>
                        </div>
                      </div>
                      <div class="card-body">
                        <div class="row g-3">
                          <!-- Número de Viaje -->
                          <div class="col-md-4">
                            <label class="form-label fw-semibold">
                              <i class="fas fa-route text-danger me-1"></i>
                              Número de Viaje
                            </label>
                            <div class="input-group">
                              <span
                                class="input-group-text bg-danger bg-opacity-10"
                              >
                                <i class="fas fa-route text-danger"></i>
                              </span>
                              <input
                                type="number"
                                class="form-control"
                                v-model="filtrosExportar.viaje_id"
                                placeholder="Ej: 432"
                              />
                            </div>
                            <small class="text-muted">
                              <i class="fas fa-info-circle me-1"></i>
                              Con este filtro, las fechas son opcionales
                            </small>
                          </div>

                          <!-- Placa -->
                          <div class="col-md-4">
                            <label class="form-label fw-semibold">
                              <i class="fas fa-truck text-success me-1"></i>
                              Placa del Vehículo
                            </label>
                            <div class="input-group">
                              <span
                                class="input-group-text bg-success bg-opacity-10"
                              >
                                <i class="fas fa-truck text-success"></i>
                              </span>
                              <input
                                type="text"
                                class="form-control text-uppercase"
                                v-model="filtrosExportar.placa"
                                placeholder="Ej: ABC123"
                                @input="
                                  filtrosExportar.placa = filtrosExportar.placa.toUpperCase()
                                "
                              />
                            </div>
                          </div>

                          <!-- Tipo de Novedad -->
                          <div class="col-md-4">
                            <label class="form-label fw-semibold">
                              <i
                                class="fas fa-exclamation-triangle text-warning me-1"
                              ></i>
                              Tipo de Novedad
                            </label>
                            <div class="input-group">
                              <span
                                class="input-group-text bg-warning bg-opacity-10"
                              >
                                <i
                                  class="fas fa-exclamation-triangle text-warning"
                                ></i>
                              </span>
                              <v-select
                                v-model="filtrosExportar.tipo_novedad"
                                :options="listasForms.tiposNovedad"
                                label="nombre"
                                :reduce="(tipo) => tipo.id"
                                placeholder="Seleccione tipo"
                                clearable
                                class="form-control border-0"
                              />
                            </div>
                          </div>

                          <!-- Sub Novedad -->
                          <div class="col-md-4">
                            <label class="form-label fw-semibold">
                              <i class="fas fa-layer-group text-info me-1"></i>
                              Sub Novedad
                            </label>
                            <div class="input-group">
                              <span
                                class="input-group-text bg-info bg-opacity-10"
                              >
                                <i class="fas fa-layer-group text-info"></i>
                              </span>
                              <v-select
                                v-model="filtrosExportar.subnovedad"
                                :options="listasForms.subNovedades"
                                label="nombre"
                                :reduce="(sub) => sub.id"
                                placeholder="Seleccione sub novedad"
                                clearable
                                class="form-control border-0"
                              />
                            </div>
                          </div>

                          <!-- Relevancia -->
                          <div class="col-md-4">
                            <label class="form-label fw-semibold">
                              <i class="fas fa-star text-danger me-1"></i>
                              Relevancia
                            </label>
                            <div class="input-group">
                              <span
                                class="input-group-text bg-danger bg-opacity-10"
                              >
                                <i class="fas fa-star text-danger"></i>
                              </span>
                              <v-select
                                v-model="filtrosExportar.relevancia"
                                :options="listasForms.relevancias"
                                label="nombre"
                                :reduce="(relevancia) => relevancia.id"
                                placeholder="Seleccione relevancia"
                                clearable
                                class="form-control border-0"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Contador de filtros activos -->
                    <div class="text-center py-3">
                      <div class="d-inline-flex align-items-center">
                        <span
                          class="badge bg-success fs-6 px-3 py-2"
                          v-if="contadorFiltrosActivos > 0"
                        >
                          <i class="fas fa-filter me-2"></i>
                          {{ contadorFiltrosActivos }} filtro(s) activo(s)
                        </span>
                        <span class="badge bg-warning fs-6 px-3 py-2" v-else>
                          <i class="fas fa-exclamation-triangle me-2"></i>
                          Seleccione al menos un filtro
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="modal-footer bg-light border-top">
                    <div
                      class="d-flex w-100 justify-content-between align-items-center"
                    >
                      <button
                        type="button"
                        class="btn btn-outline-secondary"
                        data-dismiss="modal"
                      >
                        <i class="fas fa-times me-2"></i>
                        Cancelar
                      </button>
                      <button
                        type="button"
                        class="btn btn-success px-4 py-2"
                        @click="exportarNovedades"
                        :disabled="exportando || !validarFiltrosExportacion"
                      >
                        <i
                          class="fas me-2"
                          :class="
                            exportando ? 'fa-spinner fa-spin' : 'fa-file-excel'
                          "
                        ></i>
                        {{ exportando ? "Exportando..." : "Exportar a Excel" }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- /.content -->
      </div>
      <!-- /.content-wrapper -->
    </div>
    <!-- /.wrapper -->

    <!-- Modal de Gestión de Novedades -->
    <GestionNovedadesModal
      :novedad="novedadSeleccionada"
      :visible="mostrarGestionModal"
      @cerrar="cerrarGestionModal"
      @novedad-guardada="onNovedadGuardada"
    />
  </div>
</template>

<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import moment from "moment";
import GestionNovedadesModal from "./GestionNovedadesModal.vue";
import GestionHidrocarburos from "./GestionHidrocarburos.vue";
import UltimasNovedadesTab from "./UltimasNovedadesTab.vue";
import MapaCalorNovedades from "./MapaCalorNovedades.vue";
import axios from "axios";
import Loading from "@/components/Loading";

export default {
  name: "CentralTraficoIndex",
  components: {
    vSelect,
    Loading,
    GestionNovedadesModal,
    GestionHidrocarburos,
    UltimasNovedadesTab,
    MapaCalorNovedades,
  },
  data() {
    return {
      pestañaActiva: "ultimasNovedades",
      cargando: false,
      cargandoMapa: false, // El mapa se carga con el componente
      sonidoActivo: true,
      tiempoRealActivo: false,
      intervaloTiempoReal: null,
      ultimaActualizacion: moment().format("DD/MM/YYYY HH:mm:ss"),
      novedades: [],
      pagination: {
        current_page: 1,
        last_page: 1,
        per_page: 20,
        total: 0,
      },
      filtros: {
        tipo_novedad: null,
        relevancia: null,
        estado: null,
        viaje_id: null,
        det_postulacion_id: null,
        tipo_filtro: null, // 'viaje' o 'postulacion'
        fecha: null,
        hora_inicial: null,
        per_page: 50, // Cantidad de registros por página
      },
      listasForms: {
        tiposNovedad: [],
        relevancias: [],
        subNovedades: [],
        estadosGestion: [],
      },
      // Mapa - Centrado en Colombia
      mapCenterDefault: { lat: 4.651371, lng: -74.071509 },
      mapCenter: { lat: 4.651371, lng: -74.071509 },
      mapZoom: 6,
      mapZoomDefault: 6,
      mapOptions: {
        disableDefaultUI: false,
        zoomControl: true,
        mapTypeControl: true,
        scaleControl: true,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: true,
      },
      markersNovedades: [],
      infoWindowPosition: { lat: 0, lng: 0 },
      infoWindowOpen: false,
      infoWindowContent: "",
      infoWindowOptions: {
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
      novedadSeleccionada: null,
      mostrarGestionModal: false,

      intervaloActualizacion: null,
      resizeTimeout: null,
      checkLayoutInterval: null,
      lastKnownWidth: 0,
      audioHabilitado: false,
      audioEmergencia: null,
      audioAdvertencia: null,
      mostrarFiltros: true, // Filtros visibles por defecto
      exportando: false,
      filtrosExportar: {
        fecha_desde: null,
        fecha_hasta: null,
        hora_desde: null,
        hora_hasta: null,
        placa: null,
        viaje_id: null,
        tipo_novedad: null,
        subnovedad: null,
        relevancia: null,
      },
    };
  },
  computed: {
    fechaMaxima() {
      return moment().format("YYYY-MM-DD");
    },
    filtrandoPorViaje() {
      return (
        this.filtros.viaje_id !== null &&
        this.filtros.viaje_id !== "" &&
        this.filtros.viaje_id !== undefined
      );
    },
    filtrandoPorPostulacion() {
      return (
        this.filtros.det_postulacion_id !== null &&
        this.filtros.det_postulacion_id !== "" &&
        this.filtros.det_postulacion_id !== undefined
      );
    },

    // Validación de fechas para exportar
    errorFechas() {
      if (
        !this.filtrosExportar.fecha_desde ||
        !this.filtrosExportar.fecha_hasta
      ) {
        return false;
      }
      return (
        this.filtrosExportar.fecha_hasta < this.filtrosExportar.fecha_desde
      );
    },
    mensajeErrorFechas() {
      return "La fecha final no puede ser menor a la fecha inicial";
    },
    // Contador de filtros activos
    contadorFiltrosActivos() {
      let contador = 0;
      if (this.filtrosExportar.fecha_desde) contador++;
      if (this.filtrosExportar.fecha_hasta) contador++;
      if (this.filtrosExportar.placa) contador++;
      if (this.filtrosExportar.viaje_id) contador++;
      if (this.filtrosExportar.tipo_novedad) contador++;
      if (this.filtrosExportar.subnovedad) contador++;
      if (this.filtrosExportar.relevancia) contador++;
      return contador;
    },
    // Validar que hay al menos un filtro válido
    validarFiltrosExportacion() {
      // Si hay error en fechas, no permitir exportar
      if (this.errorFechas) {
        return false;
      }

      // Si hay número de viaje, es válido (fechas son opcionales)
      if (this.filtrosExportar.viaje_id) {
        return true;
      }

      // Si no hay viaje, debe haber al menos fecha_desde O algún otro filtro
      return (
        this.filtrosExportar.fecha_desde ||
        this.filtrosExportar.placa ||
        this.filtrosExportar.tipo_novedad ||
        this.filtrosExportar.subnovedad ||
        this.filtrosExportar.relevancia
      );
    },
  },
  watch: {
    pestañaActiva(newVal) {
      // Cuando cambia la pestaña, redimensionar el mapa
      if (newVal === "ultimasNovedades") {
        this.$nextTick(() => {
          setTimeout(() => {
            this.triggerMapResize();
          }, 100);
        });
      }
    },
  },
  mounted() {
    this.cargarListas();
    this.cargarNovedades();

    // Pre-cargar los audios
    this.precargarAudios();

    // Habilitar audio con el primer clic/interacción
    this.habilitarAudioConInteraccion();

    // Verificar estado del audio después de cargar
    setTimeout(() => {
      if (!this.audioHabilitado && this.sonidoActivo) {
        this.$swal({
          icon: "warning",
          title: "⚠️ Activar Alertas Sonoras",
          html:
            "<strong>Haz clic en cualquier parte de la pantalla</strong><br>para habilitar las notificaciones de emergencias y advertencias",
          toast: false,
          position: "center",
          showConfirmButton: true,
          confirmButtonText: "Activar Ahora",
          confirmButtonColor: "#28a745",
          allowOutsideClick: false,
        }).then((result) => {
          if (result.isConfirmed) {
            // Ya se habrá activado con el clic en el botón
          }
        });
      }
    }, 2000);

    // Listener simple para resize de ventana
    window.addEventListener("resize", this.handleResize);

    // Esperar a que el DOM esté completamente cargado
    this.$nextTick(() => {
      // Forzar resize inicial
      setTimeout(() => {
        this.triggerMapResize();
      }, 300);

      // Verificación periódica cada 2 segundos (más eficiente)
      this.checkLayoutInterval = setInterval(() => {
        const contentWrapper = document.querySelector(".content-wrapper");
        if (contentWrapper) {
          const currentWidth = contentWrapper.offsetWidth;
          if (
            this.lastKnownWidth !== 0 &&
            Math.abs(currentWidth - this.lastKnownWidth) > 50
          ) {
            this.triggerMapResize();
          }
          this.lastKnownWidth = currentWidth;
        }
      }, 2000);
    });
  },
  beforeDestroy() {
    if (this.intervaloActualizacion) {
      clearInterval(this.intervaloActualizacion);
    }

    // Limpiar intervalo de tiempo real
    this.detenerActualizacionAutomatica();

    if (this.checkLayoutInterval) {
      clearInterval(this.checkLayoutInterval);
    }

    // Remover listener de resize
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    cambiarPestaña(pestaña) {
      this.pestañaActiva = pestaña;
    },

    // Función genérica para obtener propiedades según la fuente de datos
    getPropiedad(
      novedad,
      rutaViaje,
      rutaPostulacion,
      rutaDirecta = null,
      valorDefault = "N/A"
    ) {
      // Función helper para navegar por rutas anidadas
      const getNestedValue = (obj, path) => {
        return path.split(".").reduce((current, key) => current?.[key], obj);
      };

      // Función helper para concatenar valores (usando + como separador)
      const getConcatenatedValue = (obj, path) => {
        if (path.includes("+")) {
          const parts = path.split("+");
          const values = parts
            .map((part) => getNestedValue(obj, part.trim()))
            .filter((val) => val);
          return values.length > 0 ? values.join(" ") : null;
        }
        return getNestedValue(obj, path);
      };

      // Prioridad: viaje -> postulación -> directo -> default
      return (
        getConcatenatedValue(novedad, `viaje.${rutaViaje}`) ||
        getConcatenatedValue(novedad, `det_postulacion.${rutaPostulacion}`) ||
        (rutaDirecta ? getConcatenatedValue(novedad, rutaDirecta) : null) ||
        valorDefault
      );
    },

    // Métodos específicos usando la función genérica
    getPlacaVehiculo(novedad) {
      return this.getPropiedad(
        novedad,
        "vehiculo.placa",
        "vehiculo.placa",
        "vehiculo.placa",
        "N/A"
      );
    },

    getConductor(novedad) {
      // Función específica para concatenar nombres y apellidos completos
      const getNombresCompletos = (conductor) => {
        if (!conductor) return null;

        const nombres = conductor.nombres || "";
        const apellidos = conductor.apellidos || "";

        const partes = [nombres, apellidos].filter((parte) => parte.trim());
        return partes.length > 0 ? partes.join(" ") : null;
      };

      // Prioridad: viaje -> postulación -> directo
      const conductorViaje = novedad.viaje?.conductor;
      const conductorPostulacion = novedad.det_postulacion?.conductor;
      const conductorDirecto = novedad.conductor;

      return (
        getNombresCompletos(conductorViaje) ||
        getNombresCompletos(conductorPostulacion) ||
        getNombresCompletos(conductorDirecto) ||
        null
      );
    },

    // Función para obtener datos completos del conductor (objeto con toda la info)
    getConductorCompleto(novedad) {
      // Prioridad: viaje -> postulación -> directo
      const conductorViaje = novedad.viaje?.conductor;
      const conductorPostulacion = novedad.det_postulacion?.conductor;
      const conductorDirecto = novedad.conductor;

      const conductor =
        conductorViaje || conductorPostulacion || conductorDirecto;

      if (!conductor) return null;

      return {
        nombres: conductor.nombres || "",
        apellidos: conductor.apellidos || "",
        nombreCompleto: this.getConductor(novedad),
        numero_documento: conductor.numero_documento || "",
        celular: conductor.celular_principal || "",
      };
    },

    getRemolque(novedad) {
      return this.getPropiedad(
        novedad,
        "remolque.placa",
        "remolque.placa",
        null,
        null
      );
    },

    getSitioCargue(novedad) {
      return this.getPropiedad(
        novedad,
        "sitio_cargue.nombre",
        "det_solicitud_diaria.solicitud_diaria.sitio.nombre",
        null,
        "N/A"
      );
    },

    getSitioDescargue(novedad) {
      return this.getPropiedad(
        novedad,
        "sitio_descargue.nombre",
        null,
        null,
        "N/A"
      );
    },

    // Método para obtener la empresa según la fuente de datos
    getEmpresa(novedad) {
      return this.getPropiedad(
        novedad,
        null,
        "det_solicitud_diaria.empresa",
        null,
        null
      );
    },

    // Funciones específicas para datos del conductor
    getConductorDocumento(novedad) {
      return this.getPropiedad(
        novedad,
        "conductor.numero_documento",
        "conductor.numero_documento",
        "conductor.numero_documento",
        "N/A"
      );
    },

    getConductorCelular(novedad) {
      return this.getPropiedad(
        novedad,
        "conductor.celular_principal",
        "conductor.celular_principal",
        "conductor.celular_principal",
        "N/A"
      );
    },

    getConductorEmail(novedad) {
      return this.getPropiedad(
        novedad,
        "conductor.email",
        "conductor.email",
        "conductor.email",
        "N/A"
      );
    },

    toggleSonido() {
      this.sonidoActivo = !this.sonidoActivo;
      this.$swal({
        icon: "success",
        title: this.sonidoActivo ? "Sonido activado" : "Sonido desactivado",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 2000,
      });
    },

    // Método para activar/desactivar tiempo real
    verEnTiempoReal() {
      this.tiempoRealActivo = !this.tiempoRealActivo;

      if (this.tiempoRealActivo) {
        // Limpiar todos los filtros
        this.limpiarFiltros();
        // Cargar solo novedades de los últimos 20 minutos
        this.cargarNovedadesTiempoReal();
        // Iniciar actualización automática cada minuto
        this.iniciarActualizacionAutomatica();

        this.$swal({
          icon: "success",
          title: "Tiempo Real Activado",
          text:
            "Mostrando novedades de los últimos 20 minutos. Los filtros están ocultos.",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
      } else {
        // Detener actualización automática
        this.detenerActualizacionAutomatica();

        this.$swal({
          icon: "info",
          title: "Tiempo Real Desactivado",
          text: "Los filtros están habilitados nuevamente.",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
        });
      }
    },

    // Cargar novedades específicamente para tiempo real (solo 20 minutos)
    cargarNovedadesTiempoReal() {
      this.cargando = true;
      this.filtros.ultimos_minutos = 20; // Forzar 20 minutos

      this.$http
        .get("/api/admin/centralTrafico/ultimasNovedades", {
          params: {
            ultimos_minutos: 20,
            // No enviar otros filtros en tiempo real
          },
        })
        .then((response) => {
          this.novedades = response.data.data || [];
          this.ultimaActualizacion = moment().format("DD/MM/YYYY HH:mm:ss");

          if (this.novedades.length === 0) {
            this.$swal({
              icon: "info",
              title: "Sin Novedades",
              text: "No hay novedades en los últimos 20 minutos.",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 2000,
              timerProgressBar: true,
            });
          }
        })
        .catch((error) => {
          console.error("Error al cargar novedades en tiempo real:", error);
          this.$swal({
            icon: "error",
            title: "Error",
            text: "Error al cargar novedades en tiempo real",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        })
        .finally(() => {
          this.cargando = false;
        });
    },

    // Iniciar actualización automática cada minuto
    iniciarActualizacionAutomatica() {
      this.intervaloTiempoReal = setInterval(() => {
        if (this.tiempoRealActivo) {
          this.cargarNovedadesTiempoReal();
        }
      }, 60000); // 60 segundos
    },

    // Detener actualización automática
    detenerActualizacionAutomatica() {
      if (this.intervaloTiempoReal) {
        clearInterval(this.intervaloTiempoReal);
        this.intervaloTiempoReal = null;
      }
    },

    abrirModalExportar() {
      // Abrir modal de exportar usando JavaScript nativo
      const modal = document.getElementById("modalExportar");
      if (modal) {
        modal.classList.add("show");
        modal.style.display = "block";
        document.body.classList.add("modal-open");
        // Crear backdrop
        const backdrop = document.createElement("div");
        backdrop.className = "modal-backdrop fade show";
        backdrop.id = "modalBackdrop";
        document.body.appendChild(backdrop);
      }
    },

    cerrarModalExportar() {
      // Cerrar modal de exportar usando JavaScript nativo
      const modal = document.getElementById("modalExportar");
      if (modal) {
        modal.classList.remove("show");
        modal.style.display = "none";
        document.body.classList.remove("modal-open");
        // Remover backdrop
        const backdrop = document.getElementById("modalBackdrop");
        if (backdrop) {
          backdrop.remove();
        }
      }
    },

    async exportarNovedades() {
      this.exportando = true;
      try {
        // Construir parámetros
        const params = {};

        // Fechas (opcionales si hay viaje_id)
        if (this.filtrosExportar.fecha_desde) {
          const horaDesde = this.filtrosExportar.hora_desde || "00:00";
          params.fecha_desde = `${this.filtrosExportar.fecha_desde} ${horaDesde}:00`;
        }

        if (this.filtrosExportar.fecha_hasta) {
          const horaHasta = this.filtrosExportar.hora_hasta || "23:59";
          params.fecha_hasta = `${this.filtrosExportar.fecha_hasta} ${horaHasta}:59`;
        }

        // Otros filtros
        if (this.filtrosExportar.placa) {
          params.placa = this.filtrosExportar.placa;
        }
        if (this.filtrosExportar.viaje_id) {
          params.viaje_id = this.filtrosExportar.viaje_id;
        }
        if (this.filtrosExportar.tipo_novedad) {
          params.tipo_novedad = this.filtrosExportar.tipo_novedad;
        }
        if (this.filtrosExportar.subnovedad) {
          params.subnovedad = this.filtrosExportar.subnovedad;
        }
        if (this.filtrosExportar.relevancia) {
          params.relevancia = this.filtrosExportar.relevancia;
        }

        // Llamar al endpoint de exportar
        const response = await axios.get(
          "/api/admin/centralTrafico/exportarNovedades",
          {
            params,
            responseType: "blob", // Importante para descargar archivos
          }
        );

        // Crear un enlace para descargar el archivo
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;

        // Nombre del archivo con fecha
        const fechaDescarga = moment().format("YYYY-MM-DD_HH-mm");
        link.setAttribute("download", `Novedades_${fechaDescarga}.xlsx`);

        document.body.appendChild(link);
        link.click();
        link.remove();

        // Cerrar modal usando JavaScript nativo
        this.cerrarModalExportar();

        this.$swal({
          icon: "success",
          title: "Exportación Exitosa",
          text: "El archivo Excel se ha descargado correctamente",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });

        // Limpiar filtros
        this.limpiarFiltrosExportar();
      } catch (error) {
        console.error("Error al exportar:", error);
        this.$swal({
          icon: "error",
          title: "Error al Exportar",
          text:
            error.response?.data?.message ||
            "Ocurrió un error al generar el archivo Excel",
        });
      } finally {
        this.exportando = false;
      }
    },

    limpiarFiltrosExportar() {
      this.filtrosExportar = {
        fecha_desde: null,
        fecha_hasta: null,
        hora_desde: null,
        hora_hasta: null,
        placa: null,
        viaje_id: null,
        tipo_novedad: null,
        subnovedad: null,
        relevancia: null,
      };
    },

    onCantidadChange() {
      // Cuando cambia la cantidad por página, volver a la página 1 y recargar
      this.pagination.current_page = 1;
      this.getIndex();
    },

    getIndex(page = 1) {
      // Si recibimos un objeto PointerEvent, extraer el número de página
      let numeroPagina = 1;
      if (typeof page === "object" && page !== null) {
        // Si es un objeto PointerEvent, buscar la página en las propiedades
        if (page.page !== undefined) {
          numeroPagina = parseInt(page.page);
        } else if (page.current_page !== undefined) {
          numeroPagina = parseInt(page.current_page);
        } else if (page.target && page.target.value) {
          numeroPagina = parseInt(page.target.value);
        } else {
          // Si no encontramos la página, usar la página actual + 1
          numeroPagina = this.pagination.current_page + 1;
        }
      } else if (typeof page === "number" && page > 0) {
        numeroPagina = page;
      } else if (
        typeof page === "string" &&
        !isNaN(page) &&
        parseInt(page) > 0
      ) {
        numeroPagina = parseInt(page);
      } else {
        numeroPagina = 1;
      }

      // Validar que el número de página sea válido
      if (numeroPagina < 1) {
        numeroPagina = 1;
      }
      if (numeroPagina > this.pagination.last_page) {
        numeroPagina = this.pagination.last_page;
      }

      this.cargando = true;
      this.novedades = [];

      // Preparar parámetros de la consulta (sin page)
      const params = {
        tipo_novedad: this.filtros.tipo_novedad,
        relevancia: this.filtros.relevancia,
        estado: this.filtros.estado,
        per_page: this.filtros.per_page,
      };

      // Si hay viaje_id, enviar viaje_id
      if (this.filtrandoPorViaje) {
        params.viaje_id = this.filtros.viaje_id;
      } else if (this.filtrandoPorPostulacion) {
        // Si hay det_postulacion_id, enviar det_postulacion_id
        params.det_postulacion_id = this.filtros.det_postulacion_id;
      } else {
        // Si NO hay viaje_id ni det_postulacion_id, usar filtros normales
        if (this.filtros.fecha) {
          params.fecha = this.filtros.fecha;
        }
        if (this.filtros.hora_inicial) {
          params.hora_inicial = this.filtros.hora_inicial;
        }
        if (this.filtros.hora_final) {
          params.hora_final = this.filtros.hora_final;
        }
      }

      axios
        .get(
          "/api/admin/centralTrafico/ultimasNovedades?page=" + numeroPagina,
          {
            params: params,
          }
        )
        .then((response) => {
          this.pagination = response.data;
          this.novedades = response.data.data || [];
          this.cargando = false;

          // Actualizar marcadores del mapa
          this.actualizarMarcadoresMapa();
        })
        .catch((error) => {
          console.error("Error al obtener novedades:", error);
          this.$swal({
            title: "Error",
            text: "Error al cargar las novedades",
            icon: "error",
          });
          this.cargando = false;
        });
    },

    cambiarPagina(pagina) {
      // El componente laravel-vue-pagination está pasando un objeto PointerEvent
      // Necesitamos extraer el número de página del objeto
      let numeroPagina = 1;

      if (typeof pagina === "number" && pagina > 0) {
        numeroPagina = pagina;
      } else if (typeof pagina === "object" && pagina !== null) {
        // Si es un objeto PointerEvent, buscar la página en las propiedades
        if (pagina.page !== undefined) {
          numeroPagina = parseInt(pagina.page);
        } else if (pagina.current_page !== undefined) {
          numeroPagina = parseInt(pagina.current_page);
        } else if (pagina.target && pagina.target.value) {
          numeroPagina = parseInt(pagina.target.value);
        } else {
          // Si no encontramos la página, usar la página actual + 1
          numeroPagina = this.pagination.current_page + 1;
        }
      } else if (
        typeof pagina === "string" &&
        !isNaN(pagina) &&
        parseInt(pagina) > 0
      ) {
        numeroPagina = parseInt(pagina);
      } else {
        console.warn("⚠️ Página inválida recibida:", pagina, "usando página 1");
        numeroPagina = 1;
      }

      // Validar que el número de página sea válido
      if (numeroPagina < 1) {
        numeroPagina = 1;
      }
      if (numeroPagina > this.pagination.last_page) {
        numeroPagina = this.pagination.last_page;
      }
      this.getIndex(numeroPagina);
    },

    onTipoFiltroChange() {
      // Limpiar los IDs cuando cambia el tipo
      this.filtros.viaje_id = null;
      this.filtros.det_postulacion_id = null;

      // Si el tiempo real está activo, detenerlo
      if (this.tiempoRealActivo) {
        this.detenerActualizacionAutomatica();
        this.tiempoRealActivo = false;
        this.$swal({
          icon: "info",
          title: "Tiempo Real Desactivado",
          text: "No disponible al filtrar por tipo específico",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });
      }
    },

    onViajeChange() {
      // Si está filtrando por viaje y el tiempo real está activo, detenerlo
      if (this.filtrandoPorViaje && this.tiempoRealActivo) {
        if (this.intervaloActualizacion) {
          clearInterval(this.intervaloActualizacion);
          this.intervaloActualizacion = null;
        }
        this.tiempoRealActivo = false;
        this.$swal({
          icon: "info",
          title: "Tiempo Real Desactivado",
          text: "No disponible al filtrar por viaje",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });
      }

      // Si se está filtrando por viaje, limpiar fecha y hora
      if (this.filtrandoPorViaje) {
        this.filtros.fecha = null;
        this.filtros.hora_inicial = null;
      }
    },

    onPostulacionChange() {
      // Si está filtrando por postulación y el tiempo real está activo, detenerlo
      if (this.filtrandoPorPostulacion && this.tiempoRealActivo) {
        this.detenerActualizacionAutomatica();
        this.tiempoRealActivo = false;
        this.$swal({
          icon: "info",
          title: "Tiempo Real Desactivado",
          text: "No disponible al filtrar por postulación",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });
      }

      // Si se está filtrando por postulación, limpiar fecha y hora
      if (this.filtrandoPorPostulacion) {
        this.filtros.fecha = null;
        this.filtros.hora_inicial = null;
      }
    },

    async cargarListas() {
      try {
        const [
          tiposResponse,
          relevanciasResponse,
          subNovedadesResponse,
          estadosResponse,
        ] = await Promise.all([
          axios.get("/api/admin/centralTrafico/listaTiposNovedad"),
          axios.get("/api/admin/centralTrafico/listaRelevancias"),
          axios.get("/api/admin/centralTrafico/listaSubNovedades"),
          axios.get("/api/admin/centralTrafico/listaEstadosGestion"),
        ]);

        this.listasForms.tiposNovedad = tiposResponse.data.map((tipo) => ({
          id: tipo.id,
          nombre: tipo.nombre,
        }));

        this.listasForms.relevancias = relevanciasResponse.data.map(
          (relevancia) => ({
            id: relevancia.id,
            nombre: relevancia.nombre,
          })
        );

        this.listasForms.subNovedades = subNovedadesResponse.data.map(
          (sub) => ({
            id: sub.id,
            nombre: sub.nombre,
          })
        );

        this.listasForms.estadosGestion = estadosResponse.data.map(
          (estado) => ({
            id: estado.id,
            nombre: estado.nombre,
          })
        );
      } catch (error) {
        console.error("Error al cargar listas:", error);
      }
    },

    async cargarNovedades(page = 1) {
      // Redirigir a getIndex para mantener consistencia
      this.getIndex(page);
    },

    actualizarMarcadoresMapa() {
      this.markersNovedades = this.novedades
        .filter((novedad) => novedad.latitud && novedad.longitud)
        .map((novedad) => ({
          position: {
            lat: parseFloat(novedad.latitud),
            lng: parseFloat(novedad.longitud),
          },
          icon: this.getMarkerIcon(novedad.relevancia),
          novedad: novedad,
        }));
    },

    getMarkerIcon(relevancia) {
      const iconColors = {
        1: "#ffc107", // Amarillo para advertencia (relevancia 1)
        2: "#dc3545", // Rojo para emergencia (relevancia 2)
        3: "#17a2b8", // Azul para media relevancia (relevancia 3)
      };

      const color = iconColors[relevancia] || "#6c757d";

      return {
        path:
          "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z",
        fillColor: color,
        fillOpacity: 1,
        strokeColor: "#ffffff",
        strokeWeight: 2,
        scale: 1.5,
        anchor: { x: 12, y: 24 },
      };
    },

    seleccionarNovedad(novedad) {
      this.novedadSeleccionada = novedad;
      if (novedad.latitud && novedad.longitud) {
        this.mapCenter = {
          lat: parseFloat(novedad.latitud),
          lng: parseFloat(novedad.longitud),
        };
        this.mapZoom = 15;

        // Mostrar notificación
        this.$swal({
          icon: "success",
          title: "Ubicación de la novedad",
          text: `Mostrando ${this.getPlacaVehiculo(novedad)} en el mapa`,
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
        });
      }
    },

    toggleInfoWindow(marker, index) {
      this.infoWindowPosition = marker.position;
      this.infoWindowContent = this.generarContenidoInfoWindow(marker.novedad);
      this.infoWindowOpen = true;
    },

    generarContenidoInfoWindow(novedad) {
      return `
        <div class="p-2">
          <h6 class="mb-2">${novedad.nTipoNovedad || "N/A"}</h6>
          <p class="mb-1"><strong>Vehículo:</strong> ${this.getPlacaVehiculo(
            novedad
          )}</p>
          <p class="mb-1"><strong>Conductor:</strong> ${
            this.getConductor(novedad)
              ? `${this.getConductor(novedad).nombres} ${
                  this.getConductor(novedad).apellidos
                }`
              : "N/A"
          }</p>
          <p class="mb-1"><strong>Remolque:</strong> ${this.getRemolque(
            novedad
          ) || "N/A"}</p>
          <p class="mb-1"><strong>Fecha:</strong> ${this.formatFecha(
            novedad.fecha_novedad
          )}</p>
          <p class="mb-1"><strong>Dirección:</strong> ${novedad.direccion ||
            "N/A"}</p>
          <p class="mb-0"><strong>Relevancia:</strong> <span class="badge ${this.getRelevanciaColor(
            novedad.relevancia
          )}">${novedad.nRelevancia || "N/A"}</span></p>
        </div>
      `;
    },

    onMapClick(event) {
      // Manejar clics en el mapa si es necesario
    },

    buscarNovedades(page = 1) {
      this.getIndex(page);
    },

    getTipoNovedadClass(tipo) {
      // Diferentes colores según el tipo de novedad
      const tipos = {
        1: "bg-success bg-opacity-10 border border-success",
        2: "bg-danger bg-opacity-10 border border-danger",
        3: "bg-warning bg-opacity-10 border border-warning",
        4: "bg-info bg-opacity-10 border border-info",
      };
      return tipos[tipo] || "bg-light border";
    },

    getRelevanciaClass(relevancia) {
      const clases = {
        1: "bg-danger bg-opacity-10 border border-danger",
        2: "bg-warning bg-opacity-10 border border-warning",
        3: "bg-success bg-opacity-10 border border-success",
      };
      return clases[relevancia] || "bg-light border";
    },

    getEstadoNovedad(novedad) {
      // Si el backend devuelve un nombre directo, úsalo
      if (novedad.nEstado && typeof novedad.nEstado === "string") {
        return novedad.nEstado;
      }

      // Caso general: resolver por id numérico contra listasForms.estadosGestion
      const id = novedad.estado;
      if (id == null) return "N/A";

      const item = (this.listasForms?.estadosGestion || []).find(
        (e) => String(e.id) === String(id)
      );
      return item ? item.nombre : id; // muestra id si no encuentra el nombre
    },

    getTipoSubNovedad(novedad) {
      // Usar los nombres que vienen del backend
      if (novedad.tipo_novedad === 1) {
        // GPS - usar nSubNovedadGps
        return novedad.nSubNovedadGps || "N/A";
      } else if (novedad.tipo_novedad === 2) {
        // Rutas - usar nSubNovedadRuta
        return novedad.nSubNovedadRuta || "N/A";
      }
      return "N/A";
    },

    getNovedadIcon(tipo) {
      // Iconos específicos según el tipo de novedad (compatibles con Font Awesome 5.15.4)
      const iconos = {
        1: "fa-satellite", // GPS - icono disponible en FA 5.15.4
        2: "fa-route", // Rutas - icono disponible en FA 5.15.4
        3: "fa-pause-circle", // Parada no programada - icono disponible en FA 5.15.4
        4: "fa-map-signs", // Ruta diferente - icono disponible en FA 5.15.4
        5: "fa-exclamation-triangle", // Emergencia - icono disponible en FA 5.15.4
      };
      return iconos[tipo] || "fa-bell";
    },

    getRelevanciaColor(relevancia) {
      // Convertir a número si viene como string
      const relevanciaNum = parseInt(relevancia);
      switch (relevanciaNum) {
        case 1:
          return "bg-warning text-dark"; // Advertencia - AMARILLO
        case 2:
          return "bg-danger text-white"; // Emergencia - ROJO
        case 3:
          return "bg-info text-white"; // Media - AZUL
        default:
          return "bg-secondary text-white";
      }
    },

    getRelevanciaButtonClass(relevancia) {
      // Convertir a número si viene como string
      const relevanciaNum = parseInt(relevancia);
      switch (relevanciaNum) {
        case 1:
          return "btn-warning"; // Advertencia - AMARILLO
        case 2:
          return "btn-danger"; // Emergencia - ROJO
        case 3:
          return "btn-info"; // Media - AZUL
        default:
          return "btn-secondary";
      }
    },

    formatFecha(fecha) {
      return moment(fecha).format("DD/MM/YYYY HH:mm");
    },

    reproducirSonidosNovedades(novedades) {
      // SIEMPRE verificar novedades de los últimos 20 minutos
      // Esto asegura que suene en cada actualización (primera carga y tiempo real)
      const tiempoLimite = 20; // minutos
      const horaLimite = moment()
        .subtract(tiempoLimite, "minutes")
        .format("YYYY-MM-DD HH:mm:ss");

      let hayEmergencia = false;
      let hayAdvertencia = false;

      // Verificar qué tipos de novedades hay
      for (let i = 0; i < novedades.length; i++) {
        const novedad = novedades[i];
        // Intentar obtener la fecha de diferentes campos posibles
        const fechaRaw =
          novedad.fecha_novedad || novedad.created_at || novedad.fecha;
        const fechaNovedad = moment(fechaRaw).format("YYYY-MM-DD HH:mm:ss");

        if (fechaNovedad >= horaLimite) {
          // Relevancia 1 = Emergencia (ROJO)
          // Relevancia 2 = Alta/Advertencia (AMARILLO)
          if (novedad.relevancia == 1) {
            hayEmergencia = true;
          } else if (novedad.relevancia == 2) {
            hayAdvertencia = true;
          }
        }
      }

      // Reproducir sonidos: primero emergencia, luego advertencia con un delay
      if (hayEmergencia) {
        this.playSound("emergencia.mp3");
      }

      if (hayAdvertencia) {
        // Si hay emergencia también, esperar 2 segundos antes de reproducir advertencia
        const delay = hayEmergencia ? 2000 : 0;
        setTimeout(() => {
          this.playSound("advertencia.mp3");
        }, delay);
      }
    },

    precargarAudios() {
      try {
        // Pre-cargar los archivos de audio
        this.audioEmergencia = new Audio(require("@/assets/emergencia.mp3"));
        this.audioAdvertencia = new Audio(require("@/assets/advertencia.mp3"));
        this.audioEmergencia.volume = 0.8;
        this.audioAdvertencia.volume = 0.8;

        // Verificar que los archivos se cargaron correctamente
        this.audioEmergencia.addEventListener("canplaythrough", () => {}, {
          once: true,
        });
        this.audioAdvertencia.addEventListener("canplaythrough", () => {}, {
          once: true,
        });
        this.audioEmergencia.addEventListener("error", (e) => {});
        this.audioAdvertencia.addEventListener("error", (e) => {});
      } catch (error) {
        console.error("Error al pre-cargar audios:", error);
      }
    },

    async habilitarAudioConInteraccion() {
      // Intentar habilitar audio automáticamente primero
      try {
        if (this.audioEmergencia) {
          this.audioEmergencia.volume = 0;
          await this.audioEmergencia.play();
          this.audioEmergencia.pause();
          this.audioEmergencia.currentTime = 0;
          this.audioEmergencia.volume = 0.8;
          this.audioHabilitado = true;
          return;
        }
      } catch (error) {
        console.log(
          "⚠️ Audio bloqueado por el navegador, esperando interacción del usuario..."
        );
      }

      const habilitarAudio = async () => {
        if (!this.audioHabilitado) {
          try {
            // Reproducir un sonido silencioso para desbloquear
            if (this.audioEmergencia) {
              this.audioEmergencia.volume = 0;
              await this.audioEmergencia.play();
              this.audioEmergencia.pause();
              this.audioEmergencia.currentTime = 0;
              this.audioEmergencia.volume = 0.8;
              this.audioHabilitado = true;

              // Mostrar confirmación visual
              this.$swal({
                icon: "success",
                title: "✅ Audio Activado",
                text: "Las alertas sonoras están habilitadas",
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 2000,
                timerProgressBar: true,
              });

              // Intentar reproducir sonidos pendientes si los hay
              if (this.novedades.length > 0) {
                setTimeout(() => {
                  this.reproducirSonidosNovedades(this.novedades);
                }, 500);
              }

              // Remover los listeners después de habilitar
              document.removeEventListener("click", habilitarAudio);
              document.removeEventListener("keydown", habilitarAudio);
            }
          } catch (error) {
            console.error("Error al habilitar audio:", error);
          }
        }
      };

      // Agregar listeners para la primera interacción
      document.addEventListener("click", habilitarAudio, { once: true });
      document.addEventListener("keydown", habilitarAudio, { once: true });
    },

    playSound(sound) {
      try {
        let audio = null;

        // Usar audios pre-cargados
        if (sound === "emergencia.mp3" && this.audioEmergencia) {
          audio = this.audioEmergencia;
        } else if (sound === "advertencia.mp3" && this.audioAdvertencia) {
          audio = this.audioAdvertencia;
        }

        if (audio) {
          // Reiniciar el audio si ya se está reproduciendo
          audio.currentTime = 0;
          audio.volume = 0.8;

          const playPromise = audio.play();

          if (playPromise !== undefined) {
            playPromise
              .then(() => {})
              .catch((error) => {
                // Si el error es por permisos del navegador
                if (error.name === "NotAllowedError") {
                  this.$swal({
                    icon: "warning",
                    title: "Audio Bloqueado",
                    text:
                      "Por favor, haz clic en cualquier parte para activar el audio",
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                  });
                }
              });
          }
        }
      } catch (error) {
        console.error("Error al reproducir sonido:", error);
      }
    },

    handleResize() {
      // Debounce para evitar múltiples llamadas
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
      }

      this.resizeTimeout = setTimeout(() => {
        this.triggerMapResize();
      }, 250);
    },

    triggerMapResize() {
      // Forzar el recalculo del tamaño del mapa
      this.$nextTick(() => {
        try {
          if (this.$refs.mapRef && this.$refs.mapRef.$mapObject) {
            if (
              window.google &&
              window.google.maps &&
              window.google.maps.event
            ) {
              window.google.maps.event.trigger(
                this.$refs.mapRef.$mapObject,
                "resize"
              );

              // Recentrar el mapa
              if (this.mapCenter) {
                this.$refs.mapRef.$mapObject.setCenter(this.mapCenter);
              }
            }
          }
        } catch (error) {
          console.error("Error al redimensionar mapa:", error);
        }
      });
    },

    // Métodos para botones de acción rápida
    limpiarFiltros() {
      this.filtros = {
        tipo_novedad: null,
        relevancia: null,
        estado: null,
        viaje_id: null,
        det_postulacion_id: null,
        tipo_filtro: null,
        fecha: null,
        hora_inicial: null,
        per_page: 50,
      };
      this.buscarNovedades();
      this.$swal({
        icon: "success",
        title: "Filtros Limpiados",
        text: "Todos los filtros han sido restablecidos",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 2000,
      });
    },

    aplicarFiltroRapido(tipo) {
      switch (tipo) {
        case "hoy":
          this.filtros.fecha = moment().format("YYYY-MM-DD");
          this.filtros.hora_inicial = null;
          this.filtros.viaje_id = null;
          this.filtros.det_postulacion_id = null;
          this.filtros.tipo_filtro = null;
          this.filtros.per_page = 50;
          break;
        case "ultimaHora":
          this.filtros.fecha = moment().format("YYYY-MM-DD");
          this.filtros.hora_inicial = moment()
            .subtract(1, "hour")
            .format("HH:mm");
          this.filtros.viaje_id = null;
          this.filtros.det_postulacion_id = null;
          this.filtros.tipo_filtro = null;
          this.filtros.per_page = 50;
          break;
        case "emergencias":
          this.filtros.relevancia = 2; // Emergencia
          this.filtros.viaje_id = null;
          this.filtros.det_postulacion_id = null;
          this.filtros.tipo_filtro = null;
          this.filtros.per_page = 50;
          break;
      }
      this.buscarNovedades();
    },

    abrirGestionModal(novedad) {
      this.novedadSeleccionada = novedad;
      this.mostrarGestionModal = true;
    },

    cerrarGestionModal() {
      this.mostrarGestionModal = false;
      this.novedadSeleccionada = null;
    },

    onNovedadGuardada() {
      // Recargar las novedades después de guardar
      this.cargarNovedades();
      this.$swal({
        icon: "success",
        title: "Novedad actualizada",
        text: "La novedad ha sido actualizada correctamente",
        timer: 2000,
        showConfirmButton: false,
      });
    },
  },
};
</script>
